import { takeEvery } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import * as logsActions from 'actions/EMSUsageReports';

const getIncidentReports = apiRequest.bind(null, logsActions.getIncidentReports, api.getIncidentReports);
const deleteIncidentReports = apiRequest.bind(null, logsActions.deleteIncidentReports, api.deleteIncidentReports);

export function* watchGetIncidentReportsRequest() {
  yield takeEvery(logsActions.GET_INCIDENT_REPORTS.REQUEST, getIncidentReports);
}

export function* watchDeleteIncidentReportsRequest() {
  yield takeEvery(logsActions.DELETE_INCIDENT_REPORTS.REQUEST, deleteIncidentReports);
}

export function* watchDeleteIncidentReportsSuccess() {
  yield takeEvery(logsActions.DELETE_INCIDENT_REPORTS.SUCCESS, getIncidentReports);
}
